import { Global } from '@emotion/react'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import React, { useState } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'

import { BirthdayCancellation } from '@components/birthdayCancellation'
import theme from '@config/theme'
import { BirthdayReservation } from '@containers/birthdayReservation'
import { GlobalStyle } from '@styles/globals'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      keepPreviousData: true,
      cacheTime: 3600000,
      staleTime: 3600000,
      retry: false,
    },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Questerland frontend requires a #root mount element.')
}

const BirthdayApp = () => {
  const [cancellationToken, setCancellationToken] = useState(() =>
    new URLSearchParams(window.location.search).get('cancelBirthday')
  )
  const closeCancellation = () => {
    const url = new URL(window.location.href)
    url.searchParams.delete('cancelBirthday')
    window.history.replaceState({}, '', url.toString())
    setCancellationToken(null)
  }

  return (
    <>
      <BirthdayReservation />
      {cancellationToken && (
        <BirthdayCancellation
          token={cancellationToken}
          onClose={closeCancellation}
        />
      )}
    </>
  )
}

createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Global styles={GlobalStyle} />
        <BirthdayApp />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
